import { colors, type } from "../styles";
import { DATE_RANGES, DateRangeKey } from "../types";

/** Preset row. One control, scoping every tile and chart on the page below it. */
const DateRangeFilter = ({
  value,
  onChange,
}: {
  value: DateRangeKey;
  onChange: (next: DateRangeKey) => void;
}) => (
  <div
    role="group"
    aria-label="Date range"
    style={{
      display: "inline-flex",
      background: colors.surface,
      border: `1px solid ${colors.border}`,
      borderRadius: 8,
      padding: 3,
      gap: 2,
    }}
  >
    {DATE_RANGES.map(option => {
      const selected = option.key === value;
      return (
        <button
          key={option.key}
          onClick={() => onChange(option.key)}
          aria-pressed={selected}
          style={{
            ...type.bodySmallMedium,
            color: selected ? colors.ink : colors.inkMuted,
            background: selected ? colors.surfaceMuted : "transparent",
            border: "none",
            borderRadius: 6,
            padding: "6px 12px",
            cursor: "pointer",
            fontWeight: selected ? 600 : 500,
          }}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

export default DateRangeFilter;
